import React, {useEffect, useState} from "react";
import {Animate} from "react-simple-animate";

export interface IFadeContentProps {
  fadeContent: boolean;
  children: JSX.Element | JSX.Element[];
}

const FadeContent: React.FC<IFadeContentProps> = (props) => {
  const [displayNone, setDisplayNone] = useState(false);
  useEffect(() => {
    if (!props.fadeContent) {
      setDisplayNone(false);
    }
  }, [props.fadeContent]);

  // Ignoring visual changes in tests as we test the eventual state instead
  /* istanbul ignore next */
  return (
    <Animate
      play={!props.fadeContent}
      start={{opacity: 0, display: "none"}}
      end={{opacity: 1}}
    >
      <Animate
        play={props.fadeContent}
        start={{opacity: 1}}
        end={{opacity: 0}}
        onComplete={() => setDisplayNone(true)}
      >
        <div style={{display: displayNone ? "none" : "inline"}}>
          {props.children}
        </div>
      </Animate>
    </Animate>
  );
};

export default FadeContent;
